import BaseActionCreator from "actions/BaseActionCreator";
import Events from "actions/events";
import { REPORT_ORIGIN, ADMIN_ORIGIN, ServerUrls } from 'actions/config';

class SeriesActionCreator extends BaseActionCreator {
	loadPendoData () {
		return this.get(REPORT_ORIGIN, ServerUrls.Pendo.getTrackingData).then((data) => {
			// console.log('data', data);
			window.pendo.initialize({
				visitor: {
				  id: data.loginUserId,
				  firstName: data.loginUserFirstName,
				  lastName: data.loginUserLastName,
				  fullName: data.loginUserFullName,
				  email: data.loginUserEmail,
				  role: data.loginUserType
				},
				
				account: {
				  id: data.clientId,
				  name: data.clientName,
				  accountRep: data.accountExecutiveName
				}
			});
	    });
	}
	loadProductionsList () {
		const _this = this;
		return dispatch => {
			return _this.get(REPORT_ORIGIN, ServerUrls.Productions.getAll).then((data) => {
				// console.log('data', data);
	    	_this.dispatch({ type: Events.Productions.RECEIVE, data })
	    });
		}
	}
	getProductionSummary(productionId, feeInclusionRequest = { facilityFee : false, convenienceFee : false }) {
		let feeInclusionRequestParameters = "&facilityFee=" + feeInclusionRequest.facilityFee + "&convenienceFee=" + feeInclusionRequest.convenienceFee;
		return this.get(REPORT_ORIGIN, ServerUrls.Productions.getOneSummary(productionId) + feeInclusionRequestParameters).then((data) => {
			this.dispatch({type: Events.Series.SUMMARY_RECEIVE, data:{productionId, data}})
			return data;
		})
	}

	getSeriesTicketInfo(productionId, feeInclusionRequest = { facilityFee : false, convenienceFee : false }) {
		const _this = this;
		return (dispatch,getState )=> {
			let state = getState();
			let productionExistsInStore = productionId in state.ProductionSummaryReducer.productions;
			let feesChanged = false;
			if (productionExistsInStore) {
				let feesInStore = state.ProductionSummaryReducer.productions[productionId].feeInclusion;
				if (feeInclusionRequest.facilityFee !== feesInStore.facilityFee || feeInclusionRequest.convenienceFee !== feesInStore.convenienceFee) {
					feesChanged = true;
				}
			}
			let feeInclusionRequestParameters = "&facilityFee=" + feeInclusionRequest.facilityFee + "&convenienceFee=" + feeInclusionRequest.convenienceFee;
			if (!productionExistsInStore || feesChanged) {
				// getSeriesTicketRevenueGoal
				_this.get(REPORT_ORIGIN, ServerUrls.Series.getTicketRevenueGoal(productionId)).then((data) => {
					_this.dispatch({type: Events.Series.TICKET_REVENUE_GOAL, data: {productionId, data :data.result}})
				});
				// getSeriesTicketRevenue
				_this.get(REPORT_ORIGIN, ServerUrls.Series.getTicketRevenue(productionId) + feeInclusionRequestParameters).then((data) => {
					_this.dispatch({type: Events.Series.TICKET_REVENUE, data: {productionId, data :data.result}})
				});
				// getSeriesTicketQuantitySoldGoal
				_this.get(REPORT_ORIGIN, ServerUrls.Series.getTicketQuantitySoldGoal(productionId)).then((data) => {
					_this.dispatch({type: Events.Series.TICKET_QUANTITY_SOLD_GOAL, data:{productionId, data: data.result}})
				});
				// getSeriesTicketQuantitySold
				_this.get(REPORT_ORIGIN, ServerUrls.Series.getTicketQuantitySold(productionId)).then((data) => {
					_this.dispatch({type: Events.Series.TICKET_QUANTITY_SOLD, data: {productionId, data : data.result}})
				});
				// getSeriesRevenueData
				_this.get(REPORT_ORIGIN, ServerUrls.Series.getRevenueData(productionId) + feeInclusionRequestParameters).then((data) => {
					_this.dispatch({type: Events.Series.SALES_REVENUE_RECEIVE, data: {productionId, data}})
				});
				// getSeriesTicketSalesData
				_this.get(REPORT_ORIGIN, ServerUrls.Series.getSalesData(productionId) + feeInclusionRequestParameters).then((data) => {
					_this.dispatch({type: Events.Series.TICKET_BREAKDOWN_SALES_RECEIVE, data: {productionId, data}})
				});
				_this.dispatch({type: Events.Series.FEE_INCLUSION_RECEIVE, data: {productionId, data: feeInclusionRequest}});
			} else {
				return Promise.resolve();
			}
		}
	}

	getSeriesRevenueDataForDateRange(productionId, startDate, endDate) {
		const _this = this;
			return _this.get(REPORT_ORIGIN, ServerUrls.Series.getRevenueDataForDateRange(productionId, startDate, endDate)).then((data) => {
				_this.dispatch({type:  Events.Series.SALES_REVENUE_RECEIVE, data: {productionId, data :data}})
			});

	}

	getTicketBreakdownForDateRange(productionId, startDate, endDate) {
		const _this = this;
			return _this.get(REPORT_ORIGIN, ServerUrls.Series.getSalesDataForDateRange(productionId, startDate, endDate)).then((data) => {
				// console.log('TICKETTYPEBREAKDOWN', data)
				_this.dispatch({type:  Events.Series.TICKET_BREAKDOWN_SALES_RECEIVE, data: {productionId, data :data}})
			});
	}

	saveSeriesTicketRevenueGoal(productionId, value) {
		const _this = this;
		return dispatch => {
			return _this.get(ADMIN_ORIGIN, ServerUrls.Series.saveTicketRevenueGoal(productionId, value)).then((data) => {
				_this.dispatch({type: Events.Series.TICKET_REVENUE_GOAL, data: {productionId, data :data.result}})
			});
		}
	}

  saveSeriesTicketQuantitySoldGoal(productionId, value) {
		const _this = this;
		return dispatch => {
			return _this.get(ADMIN_ORIGIN, ServerUrls.Series.saveTicketQuantitySoldGoal(productionId, value)).then((data) => {
				_this.dispatch({type: Events.Series.TICKET_QUANTITY_SOLD_GOAL, data: {productionId, data : data.result}})
			});
		}
	}
  // getting 500 server code
	getSeriesComparisonData(obj, feeInclusionRequest = { facilityFee : false, convenienceFee : false }) {
		const _this = this;
		let feeInclusionRequestParameters = "?facilityFee=" + feeInclusionRequest.facilityFee + "&convenienceFee=" + feeInclusionRequest.convenienceFee;
		return _this.post(REPORT_ORIGIN, ServerUrls.Series.getSeriesComparisonData() + feeInclusionRequestParameters, obj).then((data) => {
			return data;
		});
	}

  getDnDTableData(productionId, date, feeInclusionRequest = { facilityFee : false, convenienceFee : false }) {
    // console.log("%^$E&^%&*(^%$^&*(INHERE@#$%^&*()(*&^%$", productionId, date, feeInclusionRequest);
    const _this = this;
    let feeInclusionRequestParameters = "&facilityFee=" + feeInclusionRequest.facilityFee + "&convenienceFee=" + feeInclusionRequest.convenienceFee;
    return _this.get(REPORT_ORIGIN, ServerUrls.Series.getDnDTableData(productionId, date) + feeInclusionRequestParameters).then((data) => {
      _this.dispatch({type:  Events.Series.DNDTABLE_DATA_RECEIVE, data: {productionId, data :data}})
    });
  }

  addDnDTableData(productionId, bucket) {
    const _this = this;
    // console.log("ADDBUCKET", bucket);
    return _this.post(REPORT_ORIGIN, ServerUrls.Series.addDnDTableData(productionId), bucket).then((data) => {
      // _this.dispatch({type:  Events.Series.DNDTABLE_DATA_RECEIVE, data: {productionId, data :data}})
			return data;
    });
  }

  deleteDnDTableData(productionId, id) {
    const _this = this;
    return _this.post(REPORT_ORIGIN, ServerUrls.Series.deleteDnDTableData(productionId), {id: id}).then((data) => {
      // _this.dispatch({type:  Events.Series.DNDTABLE_DATA_RECEIVE, data: {productionId, data :data}})
    });
  }

  updateDnDTableData(productionId, id, bucket) {
    const _this = this;
    let obj = { ...bucket, id: id}
    return _this.post(REPORT_ORIGIN, ServerUrls.Series.updateDnDTableData(productionId), obj).then((data) => {
      // _this.dispatch({type:  Events.Series.DNDTABLE_DATA_RECEIVE, data: {productionId, data :data}})
    });
	}

}

export default new SeriesActionCreator();



// WEBPACK FOOTER //
// ./src/actions/SeriesActionCreator.js